import React from 'react';
import { SEO } from '../../components/common/SEO';
import { Navbar } from '../../components/common/Navbar';
import { Footer } from '../../components/common/Footer';
import { EditorialHero } from './components/EditorialHero';
import { LatestNewsBar } from './components/LatestNewsBar';
import { PowerIntelligenceSection } from './components/PowerIntelligenceSection';
import { SpaqCoreSection } from './components/SpaqCoreSection';
import { OneMinuteSolarSection } from './components/OneMinuteSolarSection';
import { InTheFieldSection } from './components/InTheFieldSection';
import { AboutStripSection } from './components/AboutStripSection';
import { ContactSection } from './components/ContactSection';

export default function HomePage() {
  return (
    <div className="min-h-screen flex flex-col bg-white text-navy">
      <SEO canonicalPath="/" />
      <Navbar />

      <main className="flex-1">
        {/* =========================================================
            02 既存ヒーロー：最新写真1枚
        ========================================================= */}
        <EditorialHero />

        {/* =========================================================
            03 最新ニュース：1行の細い帯
        ========================================================= */}
        <LatestNewsBar />

        {/* =========================================================
            04〜09 新デザインセクション群
        ========================================================= */}
        <div className="spaq-home-redesign">
          {/* 04 POWER INTELLIGENCE：提供価値と3つの役割 */}
          <PowerIntelligenceSection />

          {/* 05 SPAQ CORE：濃紺の技術紹介 */}
          <SpaqCoreSection />

          {/* 06 1minute solar：明るい背景の製品紹介 */}
          <OneMinuteSolarSection />

          {/* 07 IN THE FIELD：技術が働く現場 */}
          <InTheFieldSection />

          {/* 08 ABOUT：現場の知見を、技術へ。 */}
          <AboutStripSection />

          {/* 09 CONTACT：導入と協業の2つの入口 */}
          <ContactSection />
        </div>
      </main>

      {/* =========================================================
          10 フッター
      ========================================================= */}
      <Footer />
    </div>
  );
}
